import { getLang, t } from '../i18n.ts';

/** "1 d 4 h", "3 h 20 min", "12 min", "40 s". */
export const fmtDuration = (ms: number): string => {
  if (ms <= 0) return t('time.now');
  const s = Math.ceil(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (d > 0) return `${t('time.d', { n: d })} ${t('time.h', { n: h })}`;
  if (h > 0) return `${t('time.h', { n: h })} ${t('time.m', { n: m })}`;
  if (m > 0) return t('time.m', { n: m });
  return t('time.s', { n: s });
};

/** A ticking clock for short waits: 52:07, or 1:04:09 past the hour. */
export const fmtClock = (ms: number): string => {
  const s = Math.max(0, Math.ceil(ms / 1000));
  const h = Math.floor(s / 3600);
  const mm = String(Math.floor((s % 3600) / 60)).padStart(h ? 2 : 1, '0');
  const ss = String(s % 60).padStart(2, '0');
  return h ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
};

/**
 * When a chat line was said, the way a friend would put it: "just now", "5 min ago", "2 h ago",
 * "yesterday 21:40", "Mon 21:40", "3 Oct". `at` comes from the server's clock: a little ahead of ours reads as just now.
 */
export const fmtWhen = (at: number, now: number): string => {
  const ago = now - at;
  if (ago < 60_000) return t('time.justNow');
  if (ago < 3_600_000) return t('log.ago', { t: t('time.m', { n: Math.floor(ago / 60_000) }) });
  const then = new Date(at);
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  const days = Math.ceil((today.getTime() - then.getTime()) / 86_400_000);
  if (days <= 0) return t('log.ago', { t: t('time.h', { n: Math.floor(ago / 3_600_000) }) });
  const lang = getLang();
  const clock = then.toLocaleTimeString(lang, { hour: '2-digit', minute: '2-digit' });
  if (days === 1) return t('time.yesterday', { time: clock });
  if (days < 7) return `${then.toLocaleDateString(lang, { weekday: 'short' }).replace('.', '')} ${clock}`;
  return then.toLocaleDateString(lang, { day: 'numeric', month: 'short' }).replace('.', '');
};

/** The full date and time, for a hover over a short "when". */
export const fmtStamp = (at: number): string => new Date(at).toLocaleString(getLang(), { dateStyle: 'medium', timeStyle: 'short' });
